import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Text = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.paragraph)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.paragraph)}
`;
